import React from 'react';
import { useTranslation } from 'react-i18next';
import RadioList, { RadioOption } from './radio/RadioList';
import Button from '../../common/button/Button';
import { FormRow } from '../../common/form/FormRow';

export type BulletPoint = {
  placeholderTranslationKey: string;
  value: React.ReactNode;
};

interface StatusChangeProps {
  status: RadioOption | null;
  setStatus: (value: RadioOption) => void;
  statusList: RadioOption[];
  bulletPoints: BulletPoint[];
  handleOkAction: () => void;
  handleCancelAction: () => void;
  isLoading?: boolean;
}

const StatusChange: React.FC<StatusChangeProps> = ({
  status,
  setStatus,
  statusList,
  bulletPoints,
  handleCancelAction,
  handleOkAction,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col pt-4">
      <div className="space-y-2 pb-8">
        {(bulletPoints || []).map((item) => (
          <FormRow
            key={item.placeholderTranslationKey}
            title={t(item.placeholderTranslationKey)}
            layout="vertical"
          >
            <div className="text-sm text-gray-700">{item.value}</div>
          </FormRow>
        ))}
      </div>
      <div className="flex flex-col justify-around gap-1 pb-8 pt-2">
        <span className="text-left text-sm font-bold">
          {t('wards.statusChange.responseDetails')}
        </span>
        <RadioList points={statusList || []} status={status} setStatus={setStatus} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Button title={t('wards.common.ok')} onClick={handleOkAction} disabled={isLoading} />
        <Button title={t('wards.common.cancel')} onClick={handleCancelAction} />
      </div>
    </div>
  );
};

export default StatusChange;
